import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiService } from '../services/api';
import toast from 'react-hot-toast';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('userToken');
    const userData = localStorage.getItem('userData');

    if (token && userData) {
      setUser(JSON.parse(userData));
      apiService.setAuthToken(token);
    }

    setLoading(false);
  }, []);

  const login = async (usernameOrEmail, password) => {
    try {
      const response = await apiService.userLogin(usernameOrEmail, password);
      const { token, ...userData } = response.data;

      localStorage.setItem('userToken', token);
      localStorage.setItem('userData', JSON.stringify(userData));

      setUser(userData);
      apiService.setAuthToken(token);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Login failed'
      };
    }
  };

  const register = async (userData) => {
    try {
      const response = await apiService.userRegister(userData);
      const { token, ...userInfo } = response.data;

      localStorage.setItem('userToken', token);
      localStorage.setItem('userData', JSON.stringify(userInfo));

      setUser(userInfo);
      apiService.setAuthToken(token);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Registration failed'
      };
    }
  };

  const logout = () => {
    try {
      localStorage.removeItem('userToken');
      localStorage.removeItem('userData');
      setUser(null);
      apiService.setAuthToken(null);
      toast.success('Logged out successfully');
      console.log('User logged out successfully');
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('An error occurred during logout');
    }
  };

  const value = {
    user,
    login,
    register,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
